import { render, staticRenderFns } from "./PeopleEvaluatedFilters.vue?vue&type=template&id=bc0c32d6"
import script from "./PeopleEvaluatedFilters.vue?vue&type=script&lang=js"
export * from "./PeopleEvaluatedFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports